import React, {Component, createRef} from 'react';

// CSS


// Helper
import {checkCookie} from '../../Helper/Cookies';
import { apiFetch, getCurrentUser } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Modal, Confirm } from '../../components/UI/Overlays';
import { EmptyState, TableWait, Alert, Tip } from '../../components/UI/Feedback';
import { Toolbar, SelectEmpty } from '../../components/UI/Controls';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { InputTextarea } from 'primereact/inputtextarea';

// Properties
const properties = require('../../properties.json');

class Notifications extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        // Submit Button
        buttonText: "إضافة اشعار",
        buttonColor: "",

        // Teacher Identifier
        branchID: getCurrentUser()?.branchId,
        companyID: properties.company_id,
        teacherId : null ,
        periodName: null ,
        globalFilter: null,
        userInput : null ,
        grade: null,
        material: null,

        getMaterialsList: [],
        // All Grades
        allGrades: [],
        // Get Data
        data:[],
        link:"",

        editableData : null ,
        schoolStageId : null ,
        visible : false ,

        // ---- the page's own states ----
        tableLoading: true,
        loadingStages: true,
        loadingMaterials: false,
        addOpen: false,
        saving: false,

        // the notice the teacher asked to delete, held while the card is up
        doomed: null,
        deleting: false,
    }

     getMaterialByStage = (schoolStagesId) => {
        // Get Materials From API
        this.setState({ loadingMaterials: true });
        apiFetch("/lookup/materials/by-stage", { query: { stageId: schoolStagesId } })
          .then((fetchMaterials) => {
            this.setState({
              getMaterialsList: fetchMaterials,
              loadingMaterials: false,
            });
          })
          .catch((error) => {
            this.setState({ loadingMaterials: false });
            console.error("Error:", error);
          });
      };


    componentDidMount () {
        document.title = properties.site_name + " | الإشعارات";
        this.allNews();
        // this.getPeriods();
       // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
        };

        apiFetch("/lookup/school-stages/by-teacher", { query: { teacherUserId: getCurrentUser()?.userId } })
          .then((grades) => {
            this.setState({ allGrades: grades, loadingStages: false });
          })
          .catch((error) => {
            this.setState({ loadingStages: false });
            console.error("Error:", error);
          });

        // Get Periods From API

    }
    // NOTE: same as links.js -- the legacy "notifications" page already calls
    // the zoomlink endpoints (there's no dedicated legacy notifications
    // resource), so this is ported to the same /zoom-links resource. Worth a
    // product/backend follow-up if notifications are meant to be distinct
    // from links going forward.
    allNews = () => {
        var _this = this ;
       // Send the data to the server
       this.setState({ tableLoading: true });
       apiFetch("/zoom-links")
       .then(done => {
        this.setState({data : done, tableLoading: false});

       })
       .catch(error => {
           console.error('Error:', error)
           this.setState({ tableLoading: false });
           _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
       });
   };

     addNews = () => {
        var _this = this ;
       // Send the data to the server
       this.setState({ saving: true });
       apiFetch("/zoom-links", {
           method: "POST",
           body: {
               link: this.state.link,
               schoolStageId: this.state.schoolStageId,
               materialId: this.state.material,
               branchId: this.state.branchID,
           },
       })
       .then(() => {
           _this.toast.current.show({severity: 'success', summary: 'تم بنجاح', detail: 'تمت إضافة الاشعار بنجاح'});
           this.allNews();
           // a save that finished the job closes the card and empties it
           this.setState({ saving: false, addOpen: false, link: "", material: null });
       })
       .catch(error => {
           console.error('Error:', error)
           this.setState({ saving: false });
           _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
       });
   };



    render() {
        const { data, tableLoading, doomed, deleting, saving } = this.state;

        let materialList = this.state.getMaterialsList.map((period) => {
            return { label: period.name, value: period.id };
          });

          const grades = this.state.allGrades.map((grade) => {
            return {
              label: grade.name,
              value: grade.id,
            };
          });

        var deletePeriod = (e) => {
            var _this = this;
            this.setState({ deleting: true });
            // Send the data to the server
            apiFetch(`/zoom-links/${e.id}`, { method: "DELETE" })
            .then(() => {
                this.setState({ doomed: null, deleting: false });
                _this.allNews();
                _this.toast.current.show({severity: 'success', summary: 'تم بنجاح', detail: 'تم الحذف بنجاح'});
            })
            .catch(error => {
                console.error('Error:', error)

                _this.setState({
                   buttonText: "إضافة الاشعار",
                   buttonColor: "",
                   doomed: null,
                   deleting: false
               });

               _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
            });
        };

        const actionBodyTemplate = (rowData) => {
            return (
                <React.Fragment>
                    <Tip text="حذف الإشعار">
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => this.setState({ doomed: rowData })} />
                    </Tip>
                </React.Fragment>
            );
        }

        // who the notice is for: the stage, with the material under it
        const placeBody = (row) => (
            <span className="ui-row-lead">
                <span className="thumb is-empty" aria-hidden="true">
                    <i className="pi pi-bell"></i>
                </span>
                <span className="tx">
                    <b>{row.schoolStageName || '—'}</b>
                    <small>{row.materialName || 'من غير مادة'}</small>
                </span>
            </span>
        );

        const textBody = (row) =>
            row.link ? <span className="ui-note" title={row.link}>{row.link}</span> : <span className="ui-bits is-none">من غير نص</span>;

        const canAdd = !!(this.state.schoolStageId && this.state.material && String(this.state.link || '').trim()) && !saving;

        return (
            <>
                <Header
                    pageName="الإشعارات"
                    action={{ label: "إشعار جديد", icon: "pi pi-plus", onClick: () => this.setState({ addOpen: true }) }}
                />
                <Toast ref={this.toast}></Toast>

                {/* a notice goes to one material in one stage, so the card
                    asks for those two first and the text last */}
                <Modal
                    visible={this.state.addOpen}
                    onHide={() => this.setState({ addOpen: false })}
                    title="إشعار جديد"
                    width={520}
                    footer={
                        <button type="button" className="ui-btn is-gold" disabled={!canAdd} onClick={this.addNews}>
                            {saving ? <i className="pi pi-spin pi-spinner"></i> : <i className="pi pi-check"></i>}
                            <span>{saving ? 'جاري الإرسال…' : 'إضافة الإشعار'}</span>
                        </button>
                    }
                >
                    <div className="ui-modal-form">
                        <label className="ui-filter">
                            <span>المرحلة الدراسية</span>
                            <Dropdown
                                value={this.state.grade}
                                options={grades}
                                onChange={(e) =>
                                    this.setState(
                                        {
                                            schoolStageId: e.value,
                                            grade: e.value,
                                            material: null,
                                        },
                                        this.getMaterialByStage(e.value)
                                    )
                                }
                                name="grade"
                                placeholder="اختر"
                                emptyMessage={<SelectEmpty loading={this.state.loadingStages} text="مفيش مراحل" />}
                            />
                        </label>

                        <label className="ui-filter">
                            <span>
                                المادة
                                {!this.state.grade ? <small className="ui-fieldhint"> (اختر المرحلة الأول)</small> : null}
                            </span>
                            <Dropdown
                                value={this.state.material}
                                options={materialList}
                                disabled={!this.state.grade}
                                onChange={(e) => this.setState({ material: e.value })}
                                name="subject"
                                placeholder="اختر"
                                emptyMessage={<SelectEmpty loading={this.state.loadingMaterials} text="مفيش مواد للمرحلة دي" />}
                            />
                        </label>

                        <div className="p-inputgroup">
                            <span className="p-float-label">
                                <InputTextarea
                                    id="notice-text"
                                    rows={3}
                                    autoResize
                                    value={this.state.link}
                                    name="notice-text"
                                    onChange={(e) => {
                                        this.setState({ link: e.target.value });
                                    }}
                                />
                                <label htmlFor="notice-text">نص الإشعار</label>
                            </span>
                        </div>
                    </div>
                </Modal>

                <Confirm
                    visible={!!doomed}
                    onHide={() => this.setState({ doomed: null })}
                    name={doomed ? (doomed.materialName || doomed.schoolStageName || 'الإشعار') : ''}
                    note="الإشعار هيتشال، ومش هيبقى ظاهر للطلاب."
                    busy={deleting}
                    onConfirm={() => deletePeriod(doomed)}
                />

                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card>
                                <Alert kind="warn" title="الإشعارات والروابط على نفس المصدر">
                                    الصفحة دي بتقرا وتكتب في نفس مكان صفحة «الروابط» على السيرفر، يعني
                                    اللي يتضاف هنا هيظهر هناك كمان.
                                </Alert>

                                <Toolbar
                                    value={this.state.globalFilter || ''}
                                    onSearch={(v) => this.setState({ globalFilter: v })}
                                    placeholder="بحث بالمرحلة أو المادة"
                                    count={tableLoading ? null : `${data.length} إشعار`}
                                />

                                <DataTable
                                sortable
                                globalFilter={this.state.globalFilter}
                                 className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                                  value={data} paginator rows={10} rowsPerPageOptions={[10,20,50]}
                                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                   emptyMessage={
                                       tableLoading ? (
                                           <TableWait />
                                       ) : (
                                           <EmptyState
                                               title="مفيش إشعارات"
                                               hint="اكتب إشعار لمادة، وهيوصل لطلاب المرحلة دي"
                                               icon="pi pi-bell"
                                               action={{ label: "إشعار جديد", onClick: () => this.setState({ addOpen: true }) }}
                                           />
                                       )
                                   }>
                                    <Column
                                        sortable
                                        field="schoolStageName"
                                        header="المرحلة والمادة"
                                        body={placeBody}
                                    ></Column>
                                    <Column
                                        sortable
                                        field="materialName"
                                        header="المادة"
                                        style={{ width: '170px' }}
                                    ></Column>
                                    <Column
                                        field="link"
                                        header="الإشعار"
                                        body={textBody}
                                    ></Column>
                                    <Column header="حذف"
                                    body={actionBodyTemplate}
                                    ></Column>
                                </DataTable>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Notifications;
